import moment from "moment";
const DEFAULT_DATETIME_PATTERN = "yyyy-MM-DDTHH:mm:ss"

export function formatDatetime(dateString, formatPattern = DEFAULT_DATETIME_PATTERN, withUTC = false) {
    const momentObject = moment(dateString).utc(withUTC)
    return dateString && momentObject.isValid() ? momentObject.format(formatPattern) : ''
}